PF.FileList.DocItem = class DocItem extends PF.FileList.Item
	{
	static get options()
		{
		return {};
		}

	get renderer()
		{
		//language=HTML
		return `
			<div pf="item" class="row doc-item" style="padding: 8px;flex-wrap: nowrap;display: flex;  position: relative; margin-right: 8px; justify-content: flex-start; color: #000; width:100%;">
				<div style="position: relative;min-width: 60px;min-height: 60px;">
					<img pf="img" src="" style="height:60px" alt=""/>
					<div class="select-box" pf="selectBox">
						<div class="select-circle" pf="selectCircle">
							<i class="select-check material-icons">done</i>
						</div>
					</div>
				</div>
				<div style="padding: 4px 8px;">
					<span>@{model.file.name}</span><br/>
					<span style="color: #939393">@{model.file.sizeHr}</span>
				</div>
				<div class="preloader" pf="preloader" style="position: absolute; top: 20px; left:20px;">
					<span class="preloader-inner">
						<span class="preloader-inner-gap"></span>
						<span class="preloader-inner-left">
							<span class="preloader-inner-half-circle"></span>
						</span>
						<span class="preloader-inner-right">
							<span class="preloader-inner-half-circle"></span>
						</span>
					</span>
				</div>
			</div>
		`;
		}

	onRender(event)
		{
		super.onRender(event);

		this.calc('dom.img.attributes.src', 'model.file.filePreviews.img/h60.full_url');

		this.model.file.onValue('options.isUpload', true, () => {
			this.on("open", () => {
				if (this.popup === undefined)
					{
					this.initPopup();
					}
				this.popup.open();
			});
		});
		this.useTrait(PF.FileList.ImgItem.Select, this.list.fileList.selectable);
		}

	initPopup()
		{
		var encodedUrl = encodeURIComponent(this.model.file.full_url);
		this.iframeUrl = 'https://docs.google.com/viewer?url=' + encodedUrl + '&embedded=true';

		this.popup = new PF.F7Popup({
			...this.list.viewPopupConfig,
			title: this.model.file.name,
		});

		this.popup.on('opened', () => {
			this.popup.dom.iframe.node.setAttribute('src', this.iframeUrl);
		});


		this.popup.bindDom({delete: 'show'}, 'list.fileList.deletable');
		this.popup.dom.download.on('click', () => {
			PF.Model.File.download(this.model.file.full_url);
		});
		this.popup.dom.delete.on('click', () => {
			this.delete();
		});
		}

	delete(callDelete = true)
		{
		if (this.popup !== undefined)
			{
			this.popup.close();
			}
		super.delete(callDelete);
		}
	};


PF.FileList.DocItem.Select = class FileItemSelect extends PF.FileList.Item.Select
	{
	bindCheck()
		{
		this.bindDom({selectBox: 'show'}, 'list.fileList.selectMode');
		this.bindDom({selectCircle: 'class:selected'}, 'selectState');
		}
	};